import React, { useRef, useState } from "react";
import { Modal, LoadingOverlay } from "@mantine/core";
import Swal from "sweetalert2";
import PowerOfAttorneyContent from "./PowerOfAttorneyContent.jsx";
import {
  checkIsLufthansaByClaimType,
  downloadAgreementPdf,
} from "../../../../../../components/utils/airlineUtils.js";

const PowerOfAttorneyModal = ({
  isOpen,
  onRequestClose,
  formValues,
  setValue,
}) => {
  const contentRef = useRef();
  const fileInputRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isMobile = window.innerWidth < 768;

  const typeOfClaim = formValues?.type_of_claim || "";
  const originalFlights = formValues?.original_flight_details || [];
  const actualFlights = formValues?.actual_flight_details || [];

  const isLufthansa = Boolean(
    formValues?.isLufthansa !== undefined
      ? formValues.isLufthansa
      : checkIsLufthansaByClaimType({
          typeOfClaim,
          originalFlights,
          actualFlights,
        })
  );

  return (
    <>
      <LoadingOverlay
        visible={isSubmitting}
        zIndex={3000}
        fixed
        overlayProps={{ radius: "sm", blur: 1 }}
      />
      <Modal
        opened={isOpen}
        onClose={onRequestClose}
        title="Power of Attorney"
        size="800px"
        padding="md"
        fullScreen={isMobile}
      >
        <div style={{ padding: "8px 0" }}>
          <PowerOfAttorneyContent
            ref={contentRef}
            formValues={formValues}
            isModal={true}
          />

          {isLufthansa && (
            <div
              style={{
                marginTop: "20px",
                padding: "16px",
                backgroundColor: "#f0f7ff",
                border: "1px solid #bbdefb",
                borderRadius: "8px",
                textAlign: "left",
              }}
            >
              <p
                style={{
                  margin: "0 0 6px 0",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#0d47a1",
                }}
              >
                Lufthansa Physical Wet-Ink Signature Required for Power of Attorney
              </p>
              <p
                style={{
                  margin: "0 0 12px 0",
                  fontSize: "13px",
                  color: "#37474f",
                  lineHeight: "1.5",
                }}
              >
                1. Click <strong>Download PDF</strong> or <strong>Print</strong> to obtain your Power of Attorney document.<br />
                2. Print the document and have each passenger physically sign it with a pen.<br />
                3. Click <strong>Upload Signed Power of Attorney</strong> below to upload the signed file.
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <button
                  type="button"
                  style={{
                    backgroundColor: "#0d47a1",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "8px 14px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "13px",
                  }}
                  onClick={async () => {
                    setIsSubmitting(true);
                    try {
                      await downloadAgreementPdf(
                        contentRef.current,
                        "Lufthansa_Power_Of_Attorney.pdf"
                      );
                    } finally {
                      setIsSubmitting(false);
                    }
                  }}
                >
                  Download Power of Attorney (PDF)
                </button>

                <button
                  type="button"
                  style={{
                    backgroundColor: "#2e7d32",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "8px 14px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "13px",
                  }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  Upload Signed Power of Attorney
                </button>

                {/* <button
                  type="button"
                  style={{
                    backgroundColor: "#f5f5f5",
                    color: "#333",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "8px 14px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "13px",
                  }}
                  onClick={() => window.print()}
                >
                  Print
                </button> */}

                <input
                  type="file"
                  ref={fileInputRef}
                  accept=".pdf,.png,.jpg,.jpeg"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      setValue("power_of_attorney", file);
                      setValue("is_poa_checked", true);
                      onRequestClose();
                      Swal.fire({
                        icon: "success",
                        title: "Signed Power of Attorney Uploaded",
                        text: `${file.name} uploaded successfully!`,
                        confirmButtonColor: "#0d47a1",
                      });
                    }
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default PowerOfAttorneyModal;
